import React, { ReactElement } from "react";
import ButtonStyled from "../../../components/common/ButtonStyled";
import { UseFormRegister, FieldErrors, UseFormSetValue } from "react-hook-form";
import { T, useLanguage } from "../../../context/LanguageContext";

type Props = {
  title: string;
  children: React.ReactNode;
  open: boolean;

  actionButtonText: string | ReactElement | false | undefined;
  actionButtonOnClick?: React.MouseEventHandler<HTMLButtonElement>;
  actionButtonProps?: React.ComponentProps<"button">;
  actionButtonExtraClasses?: string;
  actionButtonIcon?: ReactElement | false;
  isPending?: boolean;

  register: UseFormRegister<any>;
  errors: FieldErrors;
  setValue: UseFormSetValue<any>;

  defaultValues?: any;
  readOnly?: boolean;

  onEdit?: () => void; // 👈 NEW
};

const ClientRoleAccessSection = ({
  register,
  setValue,
  defaultValues,
  readOnly,
  open,
  actionButtonText,
  actionButtonOnClick,
  actionButtonProps,
  actionButtonExtraClasses,
  actionButtonIcon,
  isPending,
  children,
  onEdit,
}: Props) => {
  const { t } = useLanguage();
  if (!open) return null;

  return (
    <div>
      {/* HEADER */}
      <div className="flex justify-between items-center h-[61.5px] px-4 border-b border-[#000000]/10">
        {/* LEFT: Client name + Edit */}
        <div className="flex items-center gap-3">
          <div>
            <p className="text-lg font-medium text-[#212121]">
              {defaultValues?.name || "Client"}
            </p>
          </div> 
        </div>

        {/* RIGHT: Actions */}
        <div className="flex items-center gap-6">
         
          {!readOnly && (
            <label className="flex items-center space-x-2 cursor-pointer">
              <div className="relative flex items-center">
                <input
                  type="checkbox"
                  disabled={readOnly}
                  {...register("globalSelectAll")}
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all bg-white checked:bg-[#FBD037]"
                />
                <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0
                  top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                  ✓
                </span>
              </div>
              <span className="text-sm font-medium text-[#212121]"><T>Select All Permissions</T></span>
            </label>
          )}
 
          {!readOnly && actionButtonText && (
            <ButtonStyled
              value={actionButtonText}
              onClick={actionButtonOnClick}
              extraClasses={actionButtonExtraClasses}
              extraProps={actionButtonProps}
              icon={actionButtonIcon}
              isPending={isPending}
            />
          )}
        </div>
      </div>

      {/* BODY */}
      {children}
    </div>
  );
};

export default ClientRoleAccessSection;
